<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script setup>
import '@/assets/css/style.css'
import '@/assets/css/mobile-clean.css'
// 组件逻辑
</script>

<style scoped>
/* 组件样式 */
</style>